export default {
    PtFieldManagerPanel: {
        avaliableFields: '可选字段',
        displayFields: '显示字段',
        patentFields: '专利字段',
        customFields: '自定义字段',
        searchPlaceholder: '查找字段',
        noData: '没有当前类型字段',
        searchNoData: '未查找到相关字段',
        spaceScopeFieldTip: '标引值仅对当前空间生效',
    },
};
